// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChartWrapper_wrapper__m_Jr-","headerWrapper":"ChartWrapper_headerWrapper__37rKb","icon":"ChartWrapper_icon__3QVop"};